import { useState } from 'react';
import { IconButton, Badge, Tooltip } from '@mui/material';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { useGetUnreadCountQuery } from '@/store/api/notificationsApi';
import { useWsFallbackPolling } from '@/hooks/useWsFallbackPolling';
import { NotificationPopover } from './NotificationPopover';

export function NotificationBell() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const fallback = useWsFallbackPolling();
  const { data } = useGetUnreadCountQuery(undefined, { ...fallback });

  const unreadCount = data?.count ?? 0;
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title="Notifications">
        <IconButton
          aria-label="Notifications"
          onClick={handleClick}
          size="small"
          sx={{ color: 'text.secondary' }}
        >
          <Badge badgeContent={unreadCount} color="error" invisible={unreadCount === 0} max={99}>
            <NotificationsOutlinedIcon fontSize="small" />
          </Badge>
        </IconButton>
      </Tooltip>

      <NotificationPopover anchorEl={anchorEl} open={open} onClose={handleClose} />
    </>
  );
}
